import { render, staticRenderFns } from "./TagBadge.vue?vue&type=template&id=2410b595&"
import script from "./TagBadge.vue?vue&type=script&lang=js&"
export * from "./TagBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports